module.exports = __webpack_public_path__ + "static/media/Buren.90b28d79.mp3";